import YFormStockAmount from './StockAmount';

export { YFormStockAmount };
export default YFormStockAmount;
